import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<canvas width={{this.size}} height={{this.size}} {{!-- template-lint-disable no-at-ember-render-modifiers --}} {{did-insert this.draw}} ...attributes />", {
  moduleName: "vagrant/components/mock-avatar/index.hbs"
});